import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BrowserModule } from '@angular/platform-browser';

import { ActivityComponent } from './activity/activity.component';

import { TasksComponent } from './tasks/tasks.component';
import { DropdownModule } from './dropdown/dropdown.module';
import { DatePickerModule } from './date-picker/date-picker.module';
import { MonthlyOverviewModule } from './dashboard/monthly-overview/monthly-overview.module';
import { QuarterlyBalanceModule } from './dashboard/quarterly-balance/quarterly-balance.module';
import { ProjectsModule } from './projects/projects.module';
import { AddCostModule } from './add-cost/add-cost.module';
import { ActionsModule } from './dashboard/actions/actions.module';
import { TopLogoBarModule } from './top-logo-bar/top-logo-bar.module';
import { DocumentModalModule } from './document-modal/document-modal.module';
import { ExpenseAccordionModule } from './project-expenses/expense-accordion/expense-accordion.module';
import { ProjectCardModule } from './project-card/project-card.module';
import { ProjectCardDataModule } from './project-card/project-card-data/project-card-data.module';
import { VersionMenuModule } from './version-menu/version-menu.module';
import { EstimatesAndInvoicesModule } from './project-expenses/estimates-and-invoices/estimates-and-invoices.module';
import { CommentPopupModule } from './comment-popup/comment-popup.module';
import { InvoiceModule } from './project-expenses/invoice/invoice.module';
import { ExpenseOverviewModule } from './project-expenses/expense-overview/expense-overview.module';
import { ProjectExpensesModule } from './project-expenses/project-expenses.module';
import { SearchBarModule } from './search-bar/search-bar.module';
import { FinanceDropdownModule } from './finance-dropdown/finance-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    DatePickerModule,
    ActionsModule,
    MonthlyOverviewModule,
    QuarterlyBalanceModule,
    DocumentModalModule,
    AddCostModule,
    ProjectsModule,
    TopLogoBarModule,
    ExpenseAccordionModule,
    ProjectCardModule,
    ProjectCardDataModule,
    VersionMenuModule,
    EstimatesAndInvoicesModule,
    ExpenseOverviewModule,
    CommentPopupModule,
    InvoiceModule,
    ProjectExpensesModule,
    FinanceDropdownModule,
    SearchBarModule,
  ],
  declarations: [ActivityComponent, TasksComponent],
  exports: [
    ActionsModule,
    ActivityComponent,
    DocumentModalModule,
    TasksComponent,
    ProjectCardModule,
    SearchBarModule,
    DropdownModule,
    DatePickerModule,
    MonthlyOverviewModule,
    QuarterlyBalanceModule,
    AddCostModule,
    ProjectsModule,
    TopLogoBarModule,
    ExpenseAccordionModule,
    EstimatesAndInvoicesModule,
    ProjectCardDataModule,
    VersionMenuModule,
    ExpenseOverviewModule,
    CommentPopupModule,
    FinanceDropdownModule,
    InvoiceModule,
    ProjectExpensesModule,
  ],
})
export class LegacyComponentsModule {}
